{
  "name": "app-totalcarepartner",
  "version": "2.6.0",
  "scripts": {
    "ng": "ng",
    "nx": "nx",
    "start": "nx serve --project=TotalCarePartner",
    "start:dev": "nx serve --configuration=dev --project=TotalCarePartner",
    "start:prod": "nx serve --configuration=prod --project=TotalCarePartner",
    "start:test": "nx serve --configuration=test --project=TotalCarePartner",
    "start:local": "nx serve --configuration=local --project=TotalCarePartner",
    "local": "nx serve --configuration=local --project=TotalCarePartner",
    "local:dev": "nx serve --configuration=dev --project=TotalCarePartner",
    "local:test": "nx serve --configuration=test --project=TotalCarePartner",
    "local:prod": "nx serve --configuration=prod --project=TotalCarePartner",
    "start:mock": "nx serve --configuration=mock --project=TotalCarePartner",
    "preinstall": "node ./scripts/copy-changelog.cjs",
    "prestart": "node ./scripts/copy-changelog.cjs",
    "prebuild": "node ./scripts/copy-changelog.cjs",
    "build": "nx build",
    "build:tst": "nx build --configuration=tst",
    "build:dev": "nx build --configuration=dev",
    "build:prod": "nx build --prod --configuration=prod",
    "test": "nx test TotalCarePartner --watch=false",
    "test:app": "nx test",
    "e2e": "npx playwright test",
    "e2e:report": "npx playwright show-report",
    "lint": "nx lint --verbose",
    "lint:fix": "nx lint --fix --verbose --cache --cacheLocation=node_modules/.cache/eslint/.eslintcache --cacheStrategy=content",
    "lint:ci:TotalCarePartner": "nx lint TotalCarePartner",
    "coverage:ci:TotalCarePartner": "nx test TotalCarePartner --parallel --coverage --skip-nx-cache --watch=false",
    "link-library": "npm link @gea/digital-ui-lib --legacy-peer-deps",
    "unlink-library": "npm unlink @gea/digital-ui-lib --legacy-peer-deps && npm install --legacy-peer-deps",
    "storybook": "nx run TotalCarePartner:storybook",
    "storybook:build": "nx run TotalCarePartner:build-storybook",
    "prettier": "npx prettier --write --cache --cache-location node_modules/.cache/prettier/.prettier-cache --cache-strategy content ./src/app",
    "storybook:prettier": "npx prettier --write ./src/app",
    "prettier:file": "npx prettier --write",
    "format": "npm run prettier & npm run lint:fix",
    "lint:file": "npx eslint --fix",
    "copy-lib": "call npm run unlink-library && call mkdir node_modules/@gea/digital-ui-lib && call cp -R ../../gea-digital-ui/gea-digital-ui-workspace/dist/gea-digital-ui-lib node_modules/@gea/digital-ui-lib",
    "prepare": "husky"
  },
  "type": "module",
  "private": true,
  "engines": {
    "node": "^22.22.3 || ^24.15.0 || >=26.0.0"
  },
  "dependencies": {
    "@angular/animations": "22.2.0",
    "@angular/cdk": "22.2.0",
    "@angular/common": "22.2.0",
    "@angular/compiler": "22.2.0",
    "@angular/core": "22.2.0",
    "@angular/forms": "22.2.0",
    "@angular/localize": "22.2.0",
    "@angular/material": "22.2.0",
    "@angular/platform-browser": "22.2.0",
    "@angular/platform-browser-dynamic": "22.2.0",
    "@angular/router": "22.2.0",
    "@azure/msal-angular": "^3.0.23",
    "@azure/msal-browser": "^3.20.0",
    "@babel/runtime": "^7.26.10",
    "@faker-js/faker": "10.1.0",
    "@gea/digital-ui-lib": "^34.0.0",
    "@ngx-translate/core": "^17.0.0",
    "@ngx-translate/http-loader": "^17.0.0",
    "@ngxs/logger-plugin": "^22.0.0",
    "@ngxs/router-plugin": "^22.0.0",
    "@ngxs/store": "^22.0.0",
    "@novnc/novnc": "^1.7.0",
    "@primeuix/themes": "^3.1.0",
    "angular-svg-icon": "^19.1.1",
    "countries-and-timezones": "^3.7.2",
    "crypto-browserify": "^3.12.1",
    "dayjs": "^1.11.19",
    "echarts": "6.0.0",
    "event-source-polyfill": "1.0.31",
    "file-saver": "^2.0.5",
    "filesize": "^11.0.13",
    "gridstack": "^12.4.2",
    "lodash": "^4.17.21",
    "luxon": "^3.6.1",
    "ngx-cookie-service": "^22.0.0",
    "ngx-file-icons": "^0.0.3",
    "ngx-skeleton-loader": "^11.3.0",
    "primeng": "^22.1.3",
    "react": "^19.2.3",
    "rxjs": "7.8.2",
    "stream-browserify": "^3.0.0",
    "tslib": "2.8.1",
    "uuid": "^13.0.0",
    "worker-timers": "8.0.27"
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "22.2.0",
    "@angular-devkit/core": "22.2.0",
    "@angular-devkit/schematics": "22.2.0",
    "@angular-eslint/builder": "22.2.0",
    "@angular-eslint/eslint-plugin": "22.2.0",
    "@angular-eslint/eslint-plugin-template": "22.2.0",
    "@angular-eslint/schematics": "22.2.0",
    "@angular-eslint/template-parser": "22.2.0",
    "@angular/build": "22.2.0",
    "@angular/cli": "22.2.0",
    "@angular/compiler-cli": "22.2.0",
    "@angular/language-service": "22.2.0",
    "@ngxs/devtools-plugin": "22.0.0",
    "@nx/angular": "23.2.1",
    "@nx/eslint": "23.2.1",
    "@nx/eslint-plugin": "23.2.1",
    "@nx/js": "23.2.1",
    "@nx/web": "23.2.1",
    "@nx/workspace": "23.2.1",
    "@playwright/test": "^1.57.0",
    "@storybook/addon-docs": "^10.1.11",
    "@storybook/angular": "^10.1.11",
    "@storybook/testing-library": "^0.2.1",
    "@swc-node/register": "^1.11.1",
    "@swc/core": "^1.15.8",
    "@swc/helpers": "^0.5.18",
    "@types/event-source-polyfill": "^1.0.5",
    "@types/file-saver": "^2.0.7",
    "@types/lodash": "^4.17.21",
    "@types/luxon": "^3.7.1",
    "@types/node": "^25.0.3",
    "@typescript-eslint/eslint-plugin": "^8.52.0",
    "@typescript-eslint/parser": "^8.52.0",
    "@typescript-eslint/utils": "^8.52.0",
    "@vitest/coverage-v8": "^5.0.5",
    "babel-loader": "10.0.0",
    "baseline-browser-mapping": "^2.9.11",
    "eslint": "^9.39.2",
    "eslint-config-prettier": "^10.1.8",
    "eslint-plugin-prettier": "^5.5.4",
    "eslint-plugin-storybook": "^10.1.11",
    "eslint-plugin-unused-imports": "^4.3.0",
    "html-webpack-plugin": "^5.6.5",
    "husky": "^9.1.7",
    "jiti": "^2.6.1",
    "jsdom": "^27.4.0",
    "jwt-decode": "^4.0.0",
    "ng-mocks": "^14.15.0",
    "ng-packagr": "^20.3.1",
    "nx": "23.2.1",
    "postcss": "^8.5.6",
    "postcss-import": "^16.1.1",
    "postcss-preset-env": "^10.6.0",
    "postcss-url": "^10.1.3",
    "prettier": "^3.7.4",
    "prettier-eslint": "^16.4.2",
    "prettier-plugin-organize-attributes": "^1.0.0",
    "remark-gfm": "^4.0.1",
    "resize-observer-polyfill": "^1.5.1",
    "rollup": "^4.55.1",
    "storybook": "^10.1.11",
    "ts-node": "^10.9.2",
    "tsx": "^4.21.0",
    "typescript": "6.0.3",
    "vitest": "^5.0.5",
    "webpack": "^5.104.1",
    "webpack-bundle-analyzer": "^5.1.0"
  },
  "resolutions": {
    "decode-uri-component": "~0.2.2",
    "loader-utils": "~2.0.4"
  }
}
